module.exports = __webpack_public_path__ + "static/media/mulan-icon.08f88d01.png";